// import React, {useEffect} from 'react'
// import "../styles/memberLogin.css"
// // import {Link} from "react-router-dom";
// // import {Link} from "react-router-dom";


// // import TextField from '@material-ui/core/TextField'
// import { Button, TextField } from '@material-ui/core'
// import { Field, Form, Formik } from 'formik'
// import { userActions } from '../actions/user.actions'
// import {useSelector,useDispatch} from 'react-redux'
// import {useHistory} from 'react-router-dom'

// function ApplicationMemberLoginHome() {

//     const LoginReducer = useSelector(state => state.LoginReducer);
//     const history = useHistory();
//     const dispatch = useDispatch();

//     useEffect(() => {
//         if (LoginReducer.loggedIn){
//         // console.log(LoginReducer.loggedIn)
//             if (LoginReducer.user.msg === "Login Successfully!"){
//                 alert(LoginReducer.user.msg)
//                 history.replace('/Reset_Password')

//             }else{
//                 alert(LoginReducer.user.msg)
//             }
        
//             // history.push('/admin/dashboard');
//         }else if(LoginReducer.error){
//             // console.log(LoginReducer.error,"err")
//             // var a=LoginReducer.error(' ')
//             // console.log(a,"aa")
//             alert("Incorrect username or password");
//         }
//     }, [LoginReducer, history])

//     const iniVal = {
//         memid: '',
//         pass: ''
//     }

//     const handleMemLogin = (values) => {
//         console.log(values);
//         dispatch(userActions.memLogin(values.memid, values.pass,"member"));
//     }
//     return (
//         <div className="memloginMain">
//             <div className="memloginContainer">
//                 <h4>Enter credentials to login</h4>
//                 <Formik initialValues={iniVal} onSubmit={handleMemLogin}>
//                     {
//                         () => (
//                             <Form>
//                                 <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
//                                     <Field name="memid" as={TextField}  label="memId / Email" variant="outlined" />
//                                     <Field name="pass" as={TextField}  label="Password" variant="outlined" type="password"/>
//                                     <Button variant="contained" color="primary" type="submit">Login</Button>

//                                 </div>
//                             </Form>
//                         )
//                     }
//                 </Formik>
//             </div>
//         </div>
//     )
// }

// export default ApplicationMemberLoginHome

import React,{useState} from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
// import "../styles/AdminForgot.css"
import "../styles/memberLogin.css"
import {Link} from "react-router-dom";
import {useHistory} from 'react-router-dom'

function  ApplicationMemberLoginHome() {
    const [passwordShown,setpasswordShown]=useState(false)
    const history = useHistory();
    const iniVal = {
        memid: '',
        pass: ''
    }
    const handlememlogin = (values) => {

            AuthService.memLogin(values.memid,values.pass).then((res)=>{
                if (res.msg === "Login Successfully!"){
                   localStorage.setItem("result", JSON.stringify(res.Data))
                    if(res.Data.is_first_login){
                        history.replace('/member/deshboard')
                    }else{
                        alert("Welcome to NMO. This is your first login on our portal. Please reset your password to continue")
                        history.replace('member/member_resetPass')
                    }
                    
                }else{
                    alert(res.msg)
                }
            })
               
    }
    const handlePass=()=>{
        setpasswordShown(true)
    }
    const handleshow=()=>{
        setpasswordShown(false)
    }
    
    return (
        
        <div className="memloginMain">
             <div className="memloginContainer">
                 <h3>NMO Member Portal</h3>
                 <h4>Enter credentials to login</h4>
                <Formik initialValues={iniVal} onSubmit={handlememlogin}>
                {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="memid" as={TextField}  label="Membership Id/Email" variant="outlined" />
                                    <Field name="pass" as={TextField}  label="Password" variant="outlined" type="password" />
                                    {/* <div className='icon'>{passwordShown?  <i class="fa fa-eye  openbtn"  onClick={handleshow}></i>: <i class="fa fa-eye-slash  openbtn"  onClick={handlePass}></i>}</div> */}
                                    <Button variant="contained" color="primary" type="submit">Login</Button>
                                    <Link className="link" to={"/MemberForgetPass"}><Button variant="contained" color="primary">Forgot Password ?</Button></Link>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
      
    )
}

export default ApplicationMemberLoginHome
